import { useRef } from 'react'
import PropTypes from 'prop-types'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/QuestionHeader.module.scss'
import titleStyle from '@aytm/app/stats/page/question-views/components/styles/QuestionTitle.module.scss'

const Header = ({ model = { text: '' } }) => {
  const { text } = model

  const componentRef = useRef(null)

  return (
    <div ref={componentRef} className={style.container}>
      <div className={style.component}>
        <div className={style.subcomponent}>
          <div className={style.questionTitleContainer}>
            <div className={titleStyle.text} dangerouslySetInnerHTML={{ __html: text || '&nbsp;' }} />
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  model: PropTypes.shape({
    text: PropTypes.string
  })
}

Header.displayName = 'Header'

export default Header
